import React from 'react';
import { MapPin, Users, Clock } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';

const ExperienceCard = ({ experience, type = 'northern-lights' }) => {
  return (
    <div className="group bg-white rounded-lg overflow-hidden shadow-sm hover:shadow-xl transition-all duration-300">
      {/* Image */}
      <div className="relative h-64 overflow-hidden">
        <img
          src={experience.image}
          alt={experience.title}
          className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
        />
        {!experience.available && (
          <div className="absolute top-4 right-4 bg-gray-900/90 text-white text-xs px-3 py-1 rounded-full">
            Coming Soon
          </div>
        )}
      </div>

      {/* Content */}
      <div className="p-6">
        <div className="flex items-center text-sm text-gray-600 mb-2">
          <MapPin size={16} className="mr-1" />
          <span>{experience.location}</span>
        </div>

        <h3 className="text-xl font-normal text-gray-900 mb-3">
          {experience.title}
        </h3>

        <p className="text-gray-600 text-sm leading-relaxed mb-4">
          {experience.description}
        </p>

        <div className="flex items-center space-x-4 text-sm text-gray-600 mb-4">
          <div className="flex items-center">
            <Clock size={16} className="mr-1" />
            <span>{experience.duration}</span>
          </div>
          <div className="flex items-center">
            <Users size={16} className="mr-1" />
            <span>{experience.groupSize}</span>
          </div>
        </div>

        <div className="flex items-center justify-between pt-4 border-t border-gray-100">
          <span className="text-2xl font-light text-gray-900">
            {experience.price}
          </span>
          <a 
            href="https://bookeo.com/lightchasingadventures" 
            target="_blank"
            rel="noopener noreferrer"
          >
            <Button
              disabled={!experience.available}
              className="bg-gray-900 text-white hover:bg-gray-800 transition-colors"
            >
              {experience.available ? 'Book Now' : 'Coming Soon'}
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default ExperienceCard;